import React from 'react'

import PropTypes from 'prop-types'

import { SVGIcon } from '..'
import { Link } from 'react-router'
import { StyledSearchButtonColumn, StyledSearchIconButton } from './styled/lib'

/**
 * The search button that toggles the search modal.
 *
 * @param {{
 *   toggleSearchModal: () => void,
 *   externalNavEnabled: boolean,
 *   iconSrc?: string,
 *   ariaLabel?: string,
 *   ...props?: object
 * }}
 * @return {React.ReactNode}
 */
const DeviceQueryToggle = ({
  toggleSearchModal,
  externalNavEnabled,
  iconSrc,
  ariaLabel,
  ...props
}) => {
  if (externalNavEnabled) return null
  return (
    <StyledSearchButtonColumn xs={12} sm={1}>
      <StyledSearchIconButton
        aria-label={ariaLabel || 'search button'}
        // onClick={() => toggleSearchModal()}
        {...props}
      > <Link to={'/kendra'} onClick={() => {}}>
         <SVGIcon src={iconSrc} />
     </Link>
       
      </StyledSearchIconButton>
    </StyledSearchButtonColumn>
  )
}

DeviceQueryToggle.propTypes = {
  toggleSearchModal: PropTypes.func.isRequired,
  externalNavEnabled: PropTypes.bool.isRequired,
  iconSrc: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string
}

export default DeviceQueryToggle



// WEBPACK FOOTER //
// ./src/components/SubHeader/DeviceQueryToggle.js